module.exports = "/_next/static/images/29003aadeb031206853aec1adcb741dd-mulher-perfil-segurando-cartao-lg@2x.jpg.webp";